import { toUpper, snakeCase } from 'lodash';

/**
 * Sam - What's happening here exactly?
 *  1. The connection params represented in the Ion pipeline variables are sometimes stored as snake case and thus
 *    need to be converted prior to comparison. The important part is that for the other params this isn't the case,
 *    and the conversion to upper snake case for those results in malformed param names.
 *
 *  2. Other comparisons in our app around this seem to allow for the possibility that params will have competing
 *    key-value pairs. The order represented here reflects the order used elsewhere in our app.
 *
 *  MORE: See `useQueryPipelineWithRoost/parseDeployedIntegrations.js` to get a picture of how legacy code has handled
 *    this scenario. That was the primary location informing this process.
 */
export default function getDeployedPipelineVariableValue({ variableKey, deployedIntegration }) {
  const associatedTransformStageParam = deployedIntegration.params.transformStage.find(
    param => param.name === variableKey
  );
  if (associatedTransformStageParam) {
    return associatedTransformStageParam.defaultValue;
  }

  const associatedConnectionParam = deployedIntegration.params.connection.find(
    param => param.name === toUpper(snakeCase(variableKey))
  );
  if (associatedConnectionParam) {
    return associatedConnectionParam.defaultValue;
  }

  const associatedSchemaParam = deployedIntegration.params.endpointSchema.find(param => param.name === variableKey);
  if (associatedSchemaParam) {
    return associatedSchemaParam.defaultValue;
  }

  return undefined;
}
